module.exports = __webpack_public_path__ + "img/湘江涂料.6030d25c.png";